import ShowPage from "../Components/ShowPage";

function Show() {
    return (
        <ShowPage />
    );
}

export default Show;